export default "__VITE_ASSET__DkrGXZgb__"